import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Video extends Component {

  static propTypes = {
    className: PropTypes.string,
    videoPath: PropTypes.string,
    videoType: PropTypes.string,
    videoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isPlaying: PropTypes.bool,
    onPlay: PropTypes.func,
    onPause: PropTypes.func,
  }

  static defaultProps = {
    className: '',
    videoPath: '',
    videoType: 'video/mp4',
    isPlaying: false,
    onPlay: () => {},
    onPause: () => {},
  }

  state = {
    showControls: false,
  }

  videoRef = React.createRef()

  componentDidUpdate(prevProps) {
    if (this.props.isPlaying && !prevProps.isPlaying) {
      this.videoRef.current.play()
    }
    if (!this.props.isPlaying && prevProps.isPlaying) {
      this.videoRef.current.pause()
    }
  }

  handleMouseEnter = () => {
    this.setState({ showControls: true })
  }

  handleMouseLeave = () => {
    this.setState({ showControls: false })
  }

  handlePauseEvent = () => {
    this.props.onPause(this.props.videoId)
  }

  handlePlayEvent = () => {
    this.props.onPlay(this.props.videoId)
  }

  render() {
    const { className, videoPath, videoType, posterPath } = this.props
    const { showControls } = this.state

    return (
      <div
        className={`our-videos-video ${className}`}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <video
          ref={this.videoRef}
          controls={showControls}
          disablePictureInPicture
          controlsList="nodownload"
          onPlay={this.handlePlayEvent}
          onPause={this.handlePauseEvent}
          poster={posterPath}
        >
          <source src={videoPath} type={videoType} />
        </video>
      </div>
    )
  }
}
